import { render } from "./subComponentDraft.vue?vue&type=template&id=6c0a2dec"
import script from "./subComponentDraft.vue?vue&type=script&lang=js"
export * from "./subComponentDraft.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__